import { createSelector } from 'reselect';

import {
  getItemById,
  getDataFromState,
} from './common';

import { getUsers } from './users';


export const getCompanies = getDataFromState('companies');

export const getFullCompanyById = createSelector(
  [getItemById('companies', 'companyId'), getUsers],
  (company, users) => {
    if (company && users) {
      return company;
    }

    return {};
  },
);



// WEBPACK FOOTER //
// ./src/redux/selectors/companies.js